// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__Ch-Gs","noFileMessage":"Home_noFileMessage__4YR1d","addFileBtn":"Home_addFileBtn__HxPLq"};